import {useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {Card, CardContent, Chip} from "@mui/material";
import MDBox from "../../components/MDBox";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import Grid from "@mui/material/Grid";
import MDTypography from "../../components/MDTypography";
import {formatCurrency, formatDateTime, getPreferenceValue} from "../common/Utils";
import MDButton from "../../components/MDButton";
import {
  getCustomerInvoices,
  getCustomerSales,
  getMyCafeOrders
} from "../common/api/PortalCustomerApi";
import {UserContext} from "../../lib/UserProvider";
import PersonIcon from "@mui/icons-material/Person";
import {CartContext} from "../../lib/CartProvider";
import {CONSTANTS} from "../common/constants";
import Meta from "../common/Meta";
import {CompanyContext} from "../../lib/CompanyProvider";

export default function CustomerPurchases(props) {
  const navigate = useNavigate();
  const [userContext, setUserContext] = useContext(UserContext);
  const [cartContext, setCartContext] = useContext(CartContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [salesResp, setSalesResp] = useState();
  const [orders, setOrders] = useState([]);
  const [invoicesResp, setInvoicesResp] = useState();
  const [salesReady, setSalesReady] = useState(false);
  const [invoicesReady, setInvoicesReady] = useState(false);

  const [invoice, setInvoice] = useState();
  const [viewingInvoice, setViewingInvoice] = useState(false);

  useEffect(() => {
    if (userContext.sessionUser?.userTypeId) {
      let showLogin = !userContext?.sessionUser?.guid?.length > 0;
      setUserContext({...userContext, showLogin: showLogin, loginNag: true});
    }
  }, [userContext?.sessionUser]);

  useEffect(() => {
    if (userContext?.reloadInvoices) {
      setTimeout(() => {
        getInvoicesFn();
      }, CONSTANTS.TOAST_TIMEOUT);
    }
  }, [userContext?.reloadInvoices]);

  const viewInvoice = (_invoice) => {
    setCartContext({...cartContext, invoice:_invoice, reloadCart: false, viewCart: true, caller: 'View invoice'});
    setViewingInvoice(true);
  }

  useEffect(() => {
    if (!userContext?.sessionUser?.guid) {
      return;
    }
    getSalesFn();
    getInvoicesFn();
    getMyCafeOrdersFn();
  }, [userContext?.sessionUser?.guid]);

  const getSalesFn = async () => {
    let result = await getCustomerSales();
    setSalesResp(result);
    setSalesReady(true);
  }

  const getMyCafeOrdersFn = async () => {
    let result = await getMyCafeOrders();
    setOrders(result);
    setSalesReady(true);
  }

  const getInvoicesFn = async () => {
    let result = await getCustomerInvoices();
    setInvoicesResp(result);
    setInvoicesReady(true);
  }
  const CHIP_COLORS = ['default','primary','secondary','error','info','success','warning'];

  return (
    <CustomerPageLayout>
      <Meta pageTitle={'Customer Purchases'}/>
      <CustomerHeader props={props}/>
      <MDBox m={1} p={1}>
        <h1>
          {companyContext?.company?.preferences && getPreferenceValue(companyContext?.company?.preferences, 'menu_item_purchases', 'My Purchases')}
          <MDButton
            color="info"
            size="small"
            style={{
              float: 'right'
            }}
            onClick={(e) => {
              navigate('/cx/my-profile');
            }}>
            <PersonIcon/>&nbsp;My Profile
          </MDButton>
        </h1>

        {orders?.length > 0 && <>
          <Grid container cols={1} spacing={3} direction="row">
            <Grid item xs={12} sm={12}>
              <Card>
                <MDBox p={2}>
                  <h5>
                    Recent Cafe Orders
                  </h5>
                  <MDBox p={1} my={2}>

                    <Grid container spacing={2}>
                      {orders?.length > 0 && <>
                        {orders?.sort((a, b) => new Date(a.createDate).getTime() - new Date(b.createDate).getTime()).map((order, idx) => {
                          return (
                            <Grid item xs={12} md={6} lg={4} key={idx}>
                              <div id={`cafe-order-${order.orderGuid}`} style={{
                                border: 'solid 1px #ddd',
                                height: '100%',
                                position: 'relative',
                                padding: '10px 10px 10px 10px',
                              }}>
                                <h5 style={{
                                  marginBottom: '2px'
                                }}>{order?.inventory?.name}
                                  <Chip
                                    style={{
                                      marginRight: '4px',
                                      float: 'right'
                                    }}
                                    color={
                                      CHIP_COLORS[order?.orderStatus.id]
                                    } label={order?.orderStatus?.name}/>

                                </h5>

                                <span className={'d-block'}><small>Ordered: {formatDateTime(order?.createDate)}</small></span>
                                <span
                                  className={'d-block'}><small>Last Updated: {formatDateTime(order?.modifyDate)}</small></span>

                                <div style={{
                                  marginTop: '8px'
                                }}>
                                  <p style={{
                                    fontSize: '0.85rem',
                                    lineHeight: '0.9rem'
                                  }}>
                                    <b>Quantity</b>&nbsp;{order?.quantity}
                                  </p>

                                  {order?.inventory?.cafeOptions?.length > 0 && <>
                                    {order?.inventory?.cafeOptions?.sort((a, b) => a.sortOrder - b.sortOrder).map((opt, idx) => {
                                      return (
                                        <p key={idx} style={{
                                          fontSize: '0.85rem',
                                          lineHeight: '0.9rem'
                                        }}>
                                          <b>{opt.optionGroupName}</b>
                                          <span style={{
                                            display: 'block'
                                          }}>
                                          {opt?.options?.sort((a, b) => a.sortOrder - b.sortOrder)?.filter(copt => !copt?.specialInstructions && !copt?.scheduleDate)?.map((copt, idx) => {
                                            return (
                                              <span key={idx}><small>{idx === 0 ? '' : ', '}{copt.optionName}
                                                &nbsp;{copt.price > 0 ? <>(+{formatCurrency(copt.price)})</> : ''}</small></span>
                                            )
                                          })
                                          }

                                            {opt?.options?.sort((a, b) => a.sortOrder - b.sortOrder)
                                              .filter(copt => copt?.scheduleDate && copt.scheduledAt?.length > 0)
                                              .map((copt, idx) => {
                                                return (
                                                  <span key={idx} style={{
                                                    display: 'block'
                                                  }}><small><b>Preferred Time:</b> {formatDateTime(copt.scheduledAt)}</small>
                                                   </span>
                                                )
                                              })
                                            }
                                            {opt?.options?.sort((a, b) => a.sortOrder - b.sortOrder)
                                              .filter(copt => copt?.specialInstructions && copt.instructions?.length > 0)
                                              .map((copt, idx) => {
                                                return (
                                                  <span key={idx} style={{
                                                    display: 'block'
                                                  }}><small><b>Instructions:</b> {copt.instructions}</small>
                                                 </span>
                                                )
                                              })
                                            }

                                        </span>
                                        </p>
                                      )
                                    })
                                    }
                                  </>}
                                </div>
                              </div>

                            </Grid>
                          )
                        })
                        }
                      </>
                      }
                    </Grid>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>

        </>}

        {invoicesReady && invoicesResp?.length > 0 &&
          <Grid container cols={1} spacing={3} direction="row">
            <Grid item xs={12} sm={12}>
              <Card>
                <MDBox p={3}>
                  <MDTypography variant={'h6'}>
                    Open Invoices
                  </MDTypography>
                  <ul className={'list-group'}>
                    {invoicesResp.sort((a, b) => b.id - a.id).map((item, index) => {
                        return (
                          <li
                            className={'list-group-item'}
                            key={index}>
                                    <span
                                      style={{
                                        float: 'right'
                                      }}>
                                      <Chip
                                        label={formatCurrency(item.amountDue)}
                                        variant="outlined"
                                        color="secondary"/>
                                    </span>
                            <a href={'#'} onClick={(e)=>{
                              e.preventDefault()
                              viewInvoice(item);
                            }}>
                              {item?.invoiceGroup ? item.referenceId : item?.inventoryItem?.name}
                            </a>
                            <br/>
                            <small>Due Date: {formatDateTime(item.dueDate)}</small>
                            <br/>
                            <MDButton color="info"
                                      size="small"
                                      onClick={(e)=>{
                              viewInvoice(item);
                            }}>Pay Now</MDButton>
                          </li>
                        )
                      }
                    )}
                  </ul>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        }
        {salesReady &&
          <Grid container cols={1} spacing={3} direction="row">
            <Grid item xs={12} sm={12}>
              <Card>
                <MDBox p={3}>
                  <MDTypography variant={'h6'}>Total Purchases</MDTypography>

                  <ul className={'list-group'}>
                    {salesReady && salesResp?.salesGroups?.length > 0 && salesResp?.salesGroups.sort((a, b) => b.id - a.id).map((item, index) => {
                        return (
                          <li
                            className={'list-group-item'}
                            key={index}>
                            <small>{formatDateTime(item.purchaseDate)}</small>
                            <br/>
                            <ul className={'list-group'}>
                              {item?.salesItems?.map((item, idx) => {
                                return (
                                  <li key={idx} className={'list-group-item'}>
                                    {item?.itemName}
                                    <span style={{
                                      float: 'right'
                                    }}>
                                        <Chip
                                          label={formatCurrency(item.total)}
                                          variant="outlined"
                                          color="secondary"/>
                                  </span>
                                </li>
                                )
                              })}
                            </ul>

                          </li>
                        )
                      }
                    )}
                  </ul>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        }
      </MDBox>
      <Footer/>
    </CustomerPageLayout>
  )
}